<lib-gung-accordion #acc="gungAccordion">
  @for (cart of data; track cart.id; let i = $index) {
    <lib-gung-accordion-item [id]="cart.id" [customHeader]="true">
      <ng-template libGungAccordionHeader>
        <div class="cart-row" [class.is-current]="cart.currentCart">
          <div class="cart-info">
            <div class="cart-title">
              {{ cart.name }}
              @if (cart.currentCart) {
                <span class="badge bg-primary ms-2" translate>CURRENT_CART</span>
              }
            </div>
            <div class="cart-meta">
              <span class="meta-item">
                <i class="fas fa-user"></i>{{ cart.customerId }}
              </span>
              <span class="meta-item">
                <i class="fas fa-calendar-alt"></i>{{ cart.creationDate | date : dateUtilService.dateFormat }}
              </span>
              <span class="meta-item">
                <i class="fas fa-box"></i>{{ cart.rows.length }}
              </span>
            </div>
          </div>
          <div class="cart-actions">
            @if (!cart.currentCart) {
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="loadCart(cart); $event.stopPropagation()"
                translate
              >LOAD_CART</button>
            }
            <button
              class="btn btn-sm btn-outline-secondary"
              (click)="fetchProductData(cart); showOpenCart(cart); $event.stopPropagation()"
              translate
            >SHOW_DETAILS</button>
            <button
              class="btn btn-sm btn-outline-danger delete-btn"
              (click)="deleteCart(cart, i); $event.stopPropagation()"
            ><i class="fas fa-trash-alt"></i></button>
          </div>
        </div>
      </ng-template>
      <ng-template libGungAccordionBody>
        <div class="cart-detail" *ngIf="mapData[cart.id]; else loading">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr>
                <th><span translate>PRODUCT_ID</span></th>
                <th><span translate>NAME</span></th>
                <th><span translate>QTY</span></th>
                <th class="text-end"><span translate>PRICE</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of mapData[cart.id]">
                <td>
                  <a [routerLink]="['/product/', row.productId]">{{ row.productId }}</a>
                </td>
                <td>{{ row?.product?.name }}</td>
                <td>{{ row.qty }}</td>
                <td class="text-end">
                  <lib-price
                    [price]="row?.product?.extra?.price?.value"
                    [currency]="row?.product?.extra?.price?.currencyCode"
                  ></lib-price>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td colspan="3" translate>SUMMARY</td>
                <td class="text-end">
                  <lib-price [price]="totalPriceByCart[cart.id]" [currency]="currencyCode"></lib-price>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </ng-template>
    </lib-gung-accordion-item>
  }
</lib-gung-accordion>

<ng-template #loading>
  <div class="text-center p-3">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</ng-template>
